module.exports = __webpack_public_path__ + "img/icon_align-right.3a6737f1.svg";